// extracted by mini-css-extract-plugin
module.exports = {"root":"BrandTemplate_root__ruhCR","brandCollezioni":"BrandTemplate_brandCollezioni__nL3CE","rotation":"BrandTemplate_rotation__goMy_"};